import React from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
var InputName = function (props) { return (React.createElement(Form.Item, { label: 'Event name', colon: false }, props.form.getFieldDecorator('name', {
    initialValue: props.initialValue || '',
    rules: [{
            required: true,
            message: 'Please have a name for your event',
        }, {
            max: 255,
            message: 'Name is too long',
        }, {
            type: 'string',
        }, {
            whitespace: true,
        }],
})(React.createElement(Input, { size: 'large', autoComplete: 'off', disabled: props.isDisabled })))); };
export default InputName;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormEventPage/FormEvent/InputName.tsx
// module id = 1104
// module chunks = 0